import { requestSuccessFailure, names } from 'utilities/constants';

export const GET_CARD_DATA_PREFIX = 'GET_CARD_DATA';
export const GET_VISITOR_PASS_PREFIX = 'GET_VISITOR_PASS';

export default {
    ...requestSuccessFailure(GET_CARD_DATA_PREFIX, GET_VISITOR_PASS_PREFIX),
    ...names(
        'SHOW_CARDHOLDER_PAGE',
        'HIDE_CARDHOLDER_PAGE',
        'SHOW_VISITOR_PASS_PAGE',
        'HIDE_VISITOR_PASS_PAGE'),

    SUBSCRIPTION_EXPIRED_ID: '3D430AA4-9330-4DF5-B715-E5626435E6BE',
    SUBSCRIPTION_PENDING_ID: 'C812A9ED-7825-4300-A5EA-879BAA4DD3F4',

    NATIONALLY_SUSPENDED_IDS: ['3D430AA4-9330-4DF5-B715-E5626435E6BE', 'C812A9ED-7825-4300-A5EA-879BAA4DD3F4'],
}